import axios from 'axios';
import { Client } from '@stomp/stompjs';
const getUrl = () => {
	const schema = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
	const url = `${schema}//${window.location.host}/direktlogin/ws`;
	return url;
};
export default {
	createWSClient(stompConfig) {
		stompConfig.brokerURL = getUrl();
		return new Client(stompConfig);
	},
	getFallback() {
		const date = new Date().getTime();
		return axios.get(`/static/portal/json/direktlogin.json?_t=${date}`);
	}
};
